<template>
  <div class="my-promotion">
    <div class="header">
      <div class="name acea-row row-center-wrapper">
        <div>當前銷售量</div>
        <!-- <router-link class="record" :to="'/user/cashrecord'">
          提现记录<span class="iconfont icon-xiangyou"></span>
        </router-link> -->
      </div>
      <div class="num" style="margin-top: 0.2rem;font-size: 0.4rem;">
        <span v-if="BrokenSale != '0'">
          <span v-for="(item, index) in BrokenSale" :key="index">
            <span v-if="index !== 0">,</span>
            <span>{{ item.number }}</span>
            <span class="attr" style="font-size: 0.25rem;"
              >({{ item.attr }})</span
            >
          </span>
        </span>
        <span v-else>0</span>
      </div>
      <!--
      <div class="profit acea-row row-between-wrapper">
        <div class="item">
          <div>一盒销量</div>
          <div class="money">
            <span v-if="BrokenSaleOne != '0'">
              <span v-for="(item, index) in BrokenSaleOne" :key="index">
                <span v-if="index !== 0">,</span>
                <span>{{ item.number }}</span>
                <span class="attr" style="font-size: 0.25rem;"
                  >({{ item.attr }})</span
                >
              </span>
            </span>
            <span v-else>0</span>
          </div>
        </div>
        <div class="item">
          <div>二盒销量</div>
          <div class="money">
            <span v-if="BrokenSaleTwo != '0'">
              <span v-for="(item, index) in BrokenSaleTwo" :key="index">
                <span v-if="index !== 0">,</span>
                <span>{{ item.number }}</span>
                <span class="attr" style="font-size: 0.25rem;"
                  >({{ item.attr }})</span
                >
              </span>
            </span>
            <span v-else>0</span>
          </div>
        </div>
      </div>-->
    </div>
    <div class="bnt" @click="toCash">添加醫生</div>
    <div class="list acea-row row-between-wrapper">
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="changeUrl('/user/poster')"
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/tgmp@3x.png" />
        </div>
        <div>學術名片</div>
      </div>
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="changeUrl('/user/promoter_list')"
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/tongji(1)@3x.png" />
        </div>
        <div>學術人統計</div>
      </div>
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission'"
      >
        <span class="iconfont icon-qiandai"></span>
        <div>佣金明细</div>
      </router-link> -->
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="changeUrl('/user/promoter_order')"
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/dingdan@3x.png" />
        </div>
        <div>學術人訂單</div>
      </div>
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="changeUrl('/user/user_tree')"
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/shuxingtu@3x.png" />
        </div>
        <div>學術樹形圖</div>
      </div>
      <div
        class="item acea-row row-center-wrapper row-column"
        @click="changeUrl('/user/doctor_list')"
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/shuxingtu@3x.png" />
        </div>
        <div>医生列表</div>
      </div>
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/doctor_audit'"
        v-if="
          userInfo.certification_type == 5 || userInfo.certification_type == 6
        "
      >
        <div class="icon-image">
          <img src="@assets/moblie/images/dingdan@3x.png" />
        </div>
        <div>醫生審核</div>
      </router-link> -->
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/promoter_rank'"
      >
        <span class="iconfont icon-paihang1"></span>
        <div>推广人排行</div>
      </router-link> -->
      <!-- <router-link
        class="item acea-row row-center-wrapper row-column"
        :to="'/user/commission/rank'"
      >
        <span class="iconfont icon-paihang"></span>
        <div>佣金排行</div>
      </router-link> -->
    </div>
  </div>
</template>
<script>
import { getUser } from "../../../../api/user";
import { getBracketValue } from "@/utils";
export default {
  name: "UserPromotion",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name == "UserPromotion") this.getInfo();
    }
  },
  computed: {
    BrokenSale() {
      let bsale = this.userInfo.broken_sale;
      return this.reformBrokenSale(bsale);
    },
    BrokenSaleOne() {
      let bsale = this.userInfo.broken_sale_one;
      return this.reformBrokenSale(bsale);
    },
    BrokenSaleTwo() {
      let bsale = this.userInfo.broken_sale_two;
      return this.reformBrokenSale(bsale);
    }
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
    getInfo: function() {
      let that = this;
      getUser().then(
        res => {
          that.userInfo = res.data;
          console.log(that.userInfo);
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    toCash: function() {
      this.$router.push({ path: "/user/user_cash" });
    },
    changeUrl(url) {
      this.$router.push({ path: url });
    },
    reformBrokenSale(bsale) {
      if (!bsale) {
        return "0";
      }
      bsale = bsale.split(",");
      console.log(getBracketValue);
      console.log(bsale);
      let newBsale = bsale.map(item => {
        let number = item.split("(")[0];
        let attr = getBracketValue(item);
        return {
          number: number,
          attr: attr
        };
      });
      console.log("new");
      console.log(newBsale);
      return newBsale;
    }
  }
};
</script>
<style lang="scss" scoped></style>
